import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In this section, the stochstic uncertainty of ray tracing (energy multiplication method  in particular) is plotted as a function of the number of rays. These errors are referenced to a reasonable 0.5 dB threshold. Modify the room volume, detection radius, time window and mean absorption to see the effect on the uncertainty of the simulation.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0328/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
